import { TxIOTable } from './TransactionInputsOutputsTable/TxIOTable';
import { TxFooter } from './TxFooter';
import { TxHeader } from './TxHeader';

export function TxRecord() {
  return (
    <div className="rounded-lg border-2 border-gray-200 bg-muted-25 p-0 shadow-sm">
      <TxHeader />
      <div className="grid grid-cols-1 gap-4 bg-white p-4 md:grid-cols-2">
        {/* Inputs */}
        <TxIOTable title="Inputs" type="inputs" />

        {/* Outputs */}
        <TxIOTable title="Outputs" type="outputs" />
      </div>
      <TxFooter />
    </div>
  );
}
